export default __webpack_public_path__ + "static/media/stolen-gray.f5b8d58e.svg";